var _ = /* @__PURE__ */ ((D) => (D[D.QR_CODE = 1] = "QR_CODE", D[D.BAR_CODE = 2] = "BAR_CODE", D[D.QR_AND_BAR_CODE = 3] = "QR_AND_BAR_CODE", D[D.HIDDEN = 4] = "HIDDEN", D))(_ || {});
export {
  _ as LoyaltyProgrammeCodeType
};
//# sourceMappingURL=loyaltyProgrammeDesignTypes.js.map
